import React, { useCallback } from "react";
import { useMainState } from "contexts/MainStateContext";
import "./CTRightMenu.css";

const CTRightMenu = ({ menuMapR }) => {
  const { showTypeForm } = useMainState();

  const handleSubmenuClick = useCallback(
    (e, submenu) => showTypeForm(e, submenu),
    [showTypeForm]
  );

  // Estado vacío
  if (!menuMapR || !(menuMapR instanceof Map) || menuMapR.size === 0) {
    return (
      <ul className="ctrightmenu-empty">
        <li>No hay ítems.</li>
      </ul>
    );
  }

  return (
    <ul className="ctrightmenu">
      {[...menuMapR.entries()].map(([key, items]) =>
        items.map((item) => (
          <li key={item.ID_MENU}>
            <button
              onClick={(e) => handleSubmenuClick(e, item)}
              className="ctrightmenu-button no-focus-style"
              disabled={item.disabled}
            >
              {item.icon && (
                <span className="ctrightmenu-icon">
                  <i className={`ct-icon-${item.icon}`}></i>
                </span>
              )}
              <span className="ctrightmenu-text">{item.DES1 || "Sin título"}</span>
              {item.submenus?.length > 0 && (
                <span className="ctrightmenu-chevron">▶</span>
              )}
            </button>
          </li>
        ))
      )}
    </ul>
  );
};

export default React.memo(CTRightMenu);